<template>
  <div class="aside-container">
    <div class="paper-left">
      <!-- 试卷信息头部 -->
      <div class="paper-header">
        <el-tooltip class="item" :content="testPaperInfo.name" placement="top" effect="light">
          <p class="paper-name">{{ testPaperInfo.name }}</p>
        </el-tooltip>

        <div class="paper-des">
          <div class="des-item">
            <i class="el-icon-trophy"></i>
            <span>总分: {{ testPaperInfo.score }}</span>
          </div>
          <div class="des-item">
            <i class="el-icon-time"></i>
            <span>时长: {{ testPaperInfo.suggestTime }}分钟</span>
          </div>
        </div>
      </div>

      <el-divider></el-divider>

      <!-- 题目导航区域 -->
      <div class="question-nav">
        <div v-for="(item,index) in allQuestionArr" :key="index" class="question-group">
          <el-tooltip class="item" :content="item.name" placement="top" effect="light" :disabled="item.name.length <= 10">
            <div class="question-type-title">
              <span class="title-dot"></span>
              <span class="title-text">{{ item.name }}</span>
            </div>
          </el-tooltip>
          <div class="question-buttons">
            <a @click="clickanchor(`#q${questionOrder}`)" v-for="questionOrder in item.questionOrder" :key="questionOrder">
              <el-tooltip 
                :content="getScratchTooltip(questionOrder)" 
                placement="top" 
                effect="light"
                :disabled="!isScratchQuestion(questionOrder)">
                <el-button size="mini" type="infor" class="subjetButton">
                  {{ questionOrder }}
                </el-button>
              </el-tooltip>
            </a>
          </div>
        </div>
      </div>

      <el-divider></el-divider>

      <!-- 操作区域 -->
      <div class="action-area">
        <div class="button-group">
          <el-button type="danger" @click="cancelSubmit" class="action-btn cancel-btn">
            <i class="el-icon-close"></i> 取消答题
          </el-button>
          <el-button type="primary" @click="submitSubject" class="action-btn submit-btn">
            <i class="el-icon-check"></i> 提交试卷
          </el-button>
        </div>

        <!-- 倒计时区域 -->
        <div class="timer-container">
          <div class="timer-box" :class="{ 'timer-warning': isTimeWarning }">
            <i class="el-icon-alarm-clock timer-icon"></i>
            <div class="timer-content">
              <span class="timer-label">剩余时间</span>
              <span class="timer-value">{{ timeShow }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {eventBus} from '@/main.js';

export default {
  props: {
    suggestTime: {
      type: Number,
      default: 60
    },
    testPaperInfo: {
      type: Object,
      default: () => ({})
    },
    allNumberArr: {
      type: Array,
      default: () => []
    },
    answerArr: {
      type: Array,
      default: () => []
    },
    allQuestionArr: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    answerArr: {
      handler: function (n, o) {
        let idArr = [];
        this.answerArr.forEach(item => {
          idArr.push(item.id)
        })
        // let butonArr = document.getElementsByClassName("subjetButton");
        const elements = this.$el.getElementsByClassName('subjetButton');
        const elementsArray = Array.from(elements);
        elementsArray.forEach((item) => {
          // console.log(item)
          let innerHTMLValue = item.getElementsByTagName("span")[0].innerHTML
          let questionOrder = parseInt(innerHTMLValue)
          // 检查是否是 Scratch 编程题
          let isScratchQuestion = this.isScratchQuestion(questionOrder)
          
          if (idArr.indexOf(questionOrder) != -1) {
            // 已答题/已上传文件：显示深绿色
            item.classList.remove("el-button--infor"); // 设置
            item.classList.remove("el-button--scratch-default"); // 移除浅绿色
            item.classList.add("el-button--success"); // 设置深绿色
          } else if (isScratchQuestion) {
            // Scratch 编程题未上传文件：显示浅绿色
            item.classList.remove("el-button--infor");
            item.classList.remove("el-button--success");
            item.classList.add("el-button--scratch-default"); // 设置浅绿色
          } else {
            // 普通题目未答题：显示默认样式
            item.classList.remove("el-button--success"); // 设置
            item.classList.remove("el-button--scratch-default");
            item.classList.add("el-button--infor"); // 设置
          }
          // if(this.answerArr.indexOf(innerHTMLValue))
        })
      },
      deep: true
    },
    allQuestionArr: {
      handler: function (n, o) {
        // 当题目数据加载后，立即更新 Scratch 题目的按钮样式
        this.$nextTick(() => {
          this.updateScratchButtonStyles();
        });
      },
      deep: true,
      immediate: true
    },
    allSecond: {
      handler: function (n, o) {
        if (this.allSecond >= 0) {
          this.timeShow = this.formatTime(this.allSecond)
        } else {
          clearInterval(this.lock);
          this.forceSubmitSubject();
          this.$alert('考试时间到', '提示', {
            showClose: false,
            closeOnClickModal: false,
            confirmButtonText: '确定',
            callback: action => {

              this.$router.push({
                name: "examinationRecord"
              })
            }
          });
        }
      }
    },
    suggestTime: {
      handler: function (n, o) {
        if (n) {
          this.startTime()
        }
      }
    }
  },
  data() {
    return {
      allSubject: [],
      time: 60,
      allSecond: null,
      timeShow: "",
      lock: null,
      timeVisible: true
    }
  },
  computed: {
    // 判断是否剩余时间少于10分钟
    isTimeWarning() {
      return this.allSecond !== null && this.allSecond < 600; // 10分钟 = 600秒
    }
  },
  methods: {
    // 检查指定题目序号是否是 Scratch 编程题
    isScratchQuestion(questionOrder) {
      for (let section of this.allQuestionArr) {
        if (section.questionItems) {
          for (let question of section.questionItems) {
            if (question.itemOrder === questionOrder && 
                question.questionType === 4 && 
                question.langCode === 'Scratch') {
              return true;
            }
          }
        }
      }
      return false;
    },
    // 获取 Scratch 题目的悬浮提示内容
    getScratchTooltip(questionOrder) {
      // 检查是否已上传文件
      const isUploaded = this.answerArr.some(item => item.id === questionOrder);
      if (isUploaded) {
        return '文件已上传';
      }
      return '未上传文件，提交时按未作答处理';
    },
    // 更新 Scratch 题目按钮的初始样式
    updateScratchButtonStyles() {
      let idArr = [];
      this.answerArr.forEach(item => {
        idArr.push(item.id)
      });
      
      const elements = this.$el.getElementsByClassName('subjetButton');
      const elementsArray = Array.from(elements);
      elementsArray.forEach((item) => {
        let innerHTMLValue = item.getElementsByTagName("span")[0].innerHTML;
        let questionOrder = parseInt(innerHTMLValue);
        let isScratchQuestion = this.isScratchQuestion(questionOrder);
        
        if (idArr.indexOf(questionOrder) != -1) {
          // 已答题/已上传文件：显示深绿色
          item.classList.remove("el-button--infor");
          item.classList.remove("el-button--scratch-default");
          item.classList.add("el-button--success");
        } else if (isScratchQuestion) {
          // Scratch 编程题未上传文件：显示浅绿色
          item.classList.remove("el-button--infor");
          item.classList.remove("el-button--success");
          item.classList.add("el-button--scratch-default");
        }
      });
    },
    isAllWrite() {
      let isOver = true
      // let butonArr = document.getElementsByClassName("subjetButton");
      const elements = this.$el.getElementsByClassName('subjetButton');
      const elementsArray = Array.from(elements);
      elementsArray.forEach((item) => {
        let innerHTMLValue = item.getElementsByTagName("span")[0].innerHTML
        // console.log(item.classList)
        item.classList.forEach(item1 => {
          // Scratch 编程题允许不上传文件，只有普通未答题按钮阻止提交
          if (item1 == "el-button--infor") {
            isOver = false
          }
        })
      })
      return isOver
    },
    clickanchor(idName) {
      this.$emit("changeMaodian", idName);
    },
    showTime() {
      console.log("this.timeShow", this.timeShow)
      this.$emit("sendshowTime", this.timeShow);
    },
    hideDiv() {
      this.timeVisible = false;
    },
    submitSubject() {
      this.isAllWrite();
      if (this.isAllWrite()) {
        this.$emit("submitPaper", parseInt(this.allSecond / 60))
      } else {
        this.$message.warning("请回答完题目")
      }

      // this.$emit("submitPaper", parseInt(this.allSecond / 60))
    },
    cancelSubmit() {
      this.$confirm('确定退出，取消答题?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // this.$router.go(-1)
        window.close()
      }).catch(() => {

      });
    },
    //时间到，强制提交
    forceSubmitSubject() {
      console.log("时间到，强制提交", parseInt(this.suggestTime));
      this.$emit("forceSubmitPaper", parseInt(this.suggestTime))
    },
    startTime() {
      this.time = Number(this.suggestTime)
      clearInterval(this.lock)
      // console.log(this.suggestTime)
      this.allSecond = Number(this.time) * 60;
      this.lock = window.setInterval(() => {
        this.allSecond--;
      }, 1000)
    },
    formatTime(time) {
      let sec = this.addZero(time % 60);
      let min = this.addZero(parseInt(time / 60));
      return `${min}:${sec}`
    },
    addZero(num) {
      if (num == 0) {
        return "00"
      } else if (num < 10) {
        return "0" + num
      } else {
        return num
      }
    }
  },
  created() {
    // 监听事件
    eventBus.$on('message-submit-paper', (data) => {
      this.submitSubject()
    });
  },
  beforeDestroy() {
    // 销毁事件监听器
    eventBus.$off('message-submit-paper');
    clearInterval(this.lock)
  }
}
</script>

<style lang="scss" scoped>
// 主容器
.aside-container {
  height: 100%;
}

// 分隔线样式
::v-deep .el-divider--horizontal {
  margin: 16px 0;
  background-color: #ebeef5;
}

// 左侧面板主体
.paper-left {
  width: 280px;
  color: #333;
  padding: 20px 16px;
  background: #fff;
}

// 试卷信息头部
.paper-header {
  padding-bottom: 5px;

  .paper-name {
    font-size: 16px;
    color: #303133;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 14px;
    line-height: 1.4;
  }

  .paper-des {
    display: flex;
    justify-content: flex-start;
    gap: 24px;

    .des-item {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 13px;
      color: #606266;

      i {
        font-size: 14px;
        color: #909399;
      }
    }
  }
}

// 题目导航区域
.question-nav {
  // 移除高度限制，让内容完全显示
}

.question-group {
  margin-bottom: 16px;
}

.question-type-title {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 10px;
  cursor: pointer;

  .title-dot {
    width: 3px;
    height: 12px;
    background: #409eff;
    border-radius: 1px;
    margin-right: 8px;
    flex-shrink: 0;
  }

  .title-text {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.question-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 2px 0;

  > a {
    width: calc((100% - 32px) / 5);
    display: block;
    text-decoration: none;
  }
}

// 题目按钮样式
.subjetButton {
  width: 48px;
  height: 36px;
  min-width: 0;
  padding: 0;
  position: relative;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #dcdfe6;
  background: #fff;
  color: #606266;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;

  ::v-deep span {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &:hover {
    cursor: pointer;
    border-color: #409eff;
    color: #409eff;
  }
}

// 已答题按钮样式（深绿色）
::v-deep .el-button--success {
  background: #67c23a !important;
  border-color: #67c23a !important;
  color: #fff !important;

  &:hover {
    background: #85ce61 !important;
    border-color: #85ce61 !important;
  }
}

// Scratch 编程题默认样式（浅绿色）
::v-deep .el-button--scratch-default {
  background: #e1f3d8 !important;
  border-color: #c2e7b0 !important;
  color: #67c23a !important;

  &:hover {
    background: #d0ecc3 !important;
    border-color: #b3e19d !important;
  }
}

// 操作区域
.action-area {
  margin-top: 5px;
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 20px;
}

.action-btn {
  padding: 9px 15px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  transition: all 0.2s;

  i {
    margin-right: 4px;
  }
}

.cancel-btn {
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;

  &:hover {
    color: #f56c6c;
    border-color: #f56c6c;
    background: #fef0f0;
  }
}

.submit-btn {
  background: #409eff;
  border: 1px solid #409eff;
  color: #fff;

  &:hover {
    background: #66b1ff;
    border-color: #66b1ff;
  }
}

// 倒计时容器
.timer-container {
  display: flex;
  justify-content: center;
}

.timer-box {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: #f0f9eb;
  border: 1px solid #e1f3d8;
  border-radius: 4px;
  padding: 12px 20px;
  transition: all 0.3s ease;

  // 警告状态：剩余时间少于10分钟
  &.timer-warning {
    background: #fef0f0;
    border-color: #fde2e2;

    .timer-icon {
      color: #f56c6c;
    }

    .timer-value {
      color: #f56c6c;
    }
  }
}

.timer-icon {
  font-size: 22px;
  color: #67c23a;
  transition: color 0.3s ease;
}

.timer-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.timer-label {
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}

.timer-value {
  font-size: 20px;
  color: #67c23a;
  font-weight: 600;
  font-family: 'Courier New', monospace;
  letter-spacing: 1px;
  transition: color 0.3s ease;
}

</style>
